import { render } from "./ReligionTable.vue?vue&type=template&id=2c605a3b&scoped=true"
import script from "./ReligionTable.vue?vue&type=script&lang=js"
export * from "./ReligionTable.vue?vue&type=script&lang=js"

import "./ReligionTable.vue?vue&type=style&index=0&id=2c605a3b&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c605a3b"]])

export default __exports__